// ===== Supabase =====
const SUPABASE_URL = 'https://rrbnvfuavesmnhziprbg.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJyYm52ZnVhdmVzbW5oemlwcmJnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzk4MjE3NzQsImV4cCI6MjA5NTM5Nzc3NH0.hUAK6sxWgquHbNoeyhk59xs-ed6gooR_O3RPLhq2qGg';

async function saveToSupabase(payload) {
  const res = await fetch(
    'https://rrbnvfuavesmnhziprbg.supabase.co/functions/v1/save-reservation',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }
  );
  if (!res.ok) {
    // The server explains refusals it expects a person to act on: the daily
    // per-email limit carries the shop's phone number so the customer can
    // still book by calling. Anything else stays the generic retry message.
    var body = null;
    try { body = await res.json(); } catch (e) { body = null; }
    var err = new Error(body && body.error ? body.error : 'save_failed');
    err.code = body && body.error;
    err.detail = body && body.detail;
    err.phone = body && body.phone;
    throw err;
  }
  return await res.json();
}

/* Why the server said no, in the customer's words. Every refusal names the
   thing to change or the number to call; until 2026-09-27 only the daily cap
   did and the rest showed a generic retry message (audit L-16). */
function tftSaveErrorText(e) {
  const phone = (e && e.phone) || SHOP_PHONE;
  switch (e && e.code) {
    case 'daily_limit':
      return (e.detail || 'オンラインでのご予約は1日3件までです。お電話にて承ります。') + '\nお電話：' + phone;
    case 'lead_time':
      return 'ご希望の受取日は受付期限を過ぎています（ケーキは3日前まで、17時以降のご注文は翌日扱い）。別の日をお選びいただくか、お電話にてご相談ください。\nお電話：' + phone;
    case 'past_date':
      return '受取日が過ぎています。別の日をお選びください。';
    case 'too_far':
      return 'オンラインでのご予約は4ヶ月先までです。それ以降はお電話にてご相談ください。\nお電話：' + phone;
    case 'shop_closed':
      return 'ご希望の受取日は休業日、またはケーキのお受け取りができない日です。別の日をお選びください。';
    case 'bad_time':
      return 'このお時間はご予約いただけません。別のお時間をお選びください。';
    case 'unknown_cake':
      return 'この組み合わせは現在受け付けておりません。ケーキの選択をご確認いただくか、お電話にてご相談ください。\nお電話：' + phone;
    case 'invalid_email':
      return 'メールアドレスの形式をご確認ください。';
    default:
      return '送信に失敗しました。お手数ですが、もう一度お試しいただくか、お電話にてご予約ください。\nお電話：' + phone;
  }
}

const SHOP_PHONE = '0740-20-6529';

/* One id per submission attempt. The server keeps it with the booking and
   answers a retry that carries the same id with that booking, so a response
   lost on the way never makes two. A new one after every success. */
function tftNewRequestId() {
  if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
  return 'r' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
}
let tftRequestId = tftNewRequestId();

// ===== データ =====
const CDN = 'https://cdn.shopify.com/s/files/1/0696/0634/2765/files/';
const CAKES = [
  { name: '生クリームケーキ', photo: CDN+'cream.png', rows: [
    { size: '4号', p: [4300, 3800, 3400, 3000] },
    { size: '5号', p: [5400, 5200, 4300, 3800] },
    { size: '6号', p: [7500, 7300, 6600, 5500] },
    { size: '7号', p: [10200, 9700, 8900, 7300] },
  ]},
  { name: 'チョコクリームケーキ', photo: CDN+'choco.png', rows: [
    { size: '4号', p: [4100, 3600, 3400, 2700] },
    { size: '5号', p: [5100, 5000, 4300, 3400] },
    { size: '6号', p: [6800, 6600, 6100, 4500] },
    { size: '7号', p: [8900, 8400, 7900, 5800] },
  ]},
  { name: 'スフレチーズケーキ', photo: CDN+'sfle.png', rows: [
    { size: '5号', p: [4200, 4000, 3900, 3000] },
    { size: '7号', p: [7300, 6900, 7100, 5000] },
  ]},
  { name: 'シフォンケーキ', photo: CDN+'chiffon.png', rows: [
    { size: '5号', p: [3900, 3700, null, 3000] },
    { size: '7号', p: [7100, 6700, null, 4800] },
  ]},
  { name: 'タルト', photo: CDN+'tart.png', rows: [
    { size: '4号', p: [2800, 2600, null, 2000] },
    { size: '5号', p: [4200, 3800, null, 2800] },
    { size: '6号', p: [5600, 5300, null, 3500] },
  ]},
  { name: 'クラシックショコラ', photo: CDN+'classic.png', rows: [
    { size: '5号', p: [5200, 4900, 5200, 4200] },
    { size: '6号', p: [6900, 6500, 6900, 5100] },
  ]},
];

const DECOS = ['いちご飾り', 'フルーツ飾り', 'マカロン飾り', '飾りなし'];

/* Whole cakes (2026-09-24): sold as themselves in a few sizes, never with a
   decoration — the four under the grid on the shop's price list. They are
   their own Shopify product (whole-cake.json, options ケーキ種類 / サイズ) and
   their code is TYPE-SIZE (PEACH-5): the same code as the Smaregi master
   product, which save-reservation prices from. Mirror of src/lib/
   cake-catalog.ts. Photos are theme assets named in the section, so a better
   photo is a re-upload under the same name, not a code change. */
const WHOLE_CAKES = [
  { name: '洋モンブラン', photo: 'mont', rows: [['6号', 5200]] },
  { name: 'ザッハトルテ', photo: 'sacher', rows: [['4号', 3900], ['5号', 4400]] },
  { name: '桃デコ', photo: 'peach', rows: [['4号', 3000], ['5号', 4100], ['6号', 5200], ['7号', 6400]] },
  { name: 'ピュアホワイト', photo: 'white', rows: [['4号', 2500], ['5号', 3500], ['6号', 4600], ['7号', 5700]] },
];
const SZ_PERSON = {'4号':'約2〜4名','5号':'約4〜6名','6号':'約6〜8名','7号':'約8〜10名'};

// ===== 状態 =====
let sel = { date: null, time: null, cake: null, price: 0, isSpecial: false, whole: null };
let calYear, calMonth;

// ===== カレンダー日付 (Supabaseから取得、失敗時はフォールバック) =====
let EXTRA_CLOSED = new Set([
  '2026-05-01', '2026-05-07',
  '2026-09-16', '2026-09-24',
  '2026-12-30', '2026-12-31',
]);
let EXTRA_OPEN = new Set([
  '2026-08-11',
  '2026-09-14',
  '2026-09-21',
  '2026-09-22',
]);
/* False until the calendar has actually been read: the sets above are a
   stale fallback, and nothing is sent on their strength (audit M-29). */
let tftCalendarLoaded = false;

async function fetchCalendarDates() {
  try {
    const [closedRes, openRes, cakeRes] = await Promise.all([
      fetch(`${SUPABASE_URL}/rest/v1/closed_dates?select=date&apikey=${SUPABASE_ANON_KEY}`),
      fetch(`${SUPABASE_URL}/rest/v1/open_dates?select=date&apikey=${SUPABASE_ANON_KEY}`),
      /* Dates the shop has closed for cake collections specifically, set from
         the dashboard calendar. The shop stays open — it just is not taking
         cake pickups that day — so these are added to the closed set here
         rather than to closed_dates, which would shut everything. */
      fetch(`${SUPABASE_URL}/rest/v1/category_dates?select=date&kind=eq.decorated_cake&available=is.false&apikey=${SUPABASE_ANON_KEY}`)
    ]);
    if (closedRes.ok && openRes.ok) {
      const closedData = await closedRes.json();
      const openData = await openRes.json();
      EXTRA_CLOSED = new Set(closedData.map(r => r.date));
      EXTRA_OPEN = new Set(openData.map(r => r.date));
      tftCalendarLoaded = cakeRes.ok;
      if (cakeRes.ok) {
        const cakeClosed = await cakeRes.json();
        cakeClosed.forEach(r => {
          EXTRA_CLOSED.add(r.date);
          /* A cake-specific closure beats a shop-wide "open exceptionally". */
          EXTRA_OPEN.delete(r.date);
        });
      }
    }
  } catch(e) {
    console.warn('カレンダー日付の取得失敗、フォールバックを使用', e);
    // Keep hardcoded fallback values defined above
  }
}

/* The shop's clock. Every date rule below is Japan's, whatever the
   customer's device is set to: today, the 17:00 cutoff and the weekday of a
   date all come from JST, and dates travel as yyyy-MM-dd strings parsed at
   UTC midnight so getUTCDay() is the date's own weekday. The server applies
   the same rules (_shared/booking-rules.ts); this keeps the calendar honest
   (2026-09-27, audit L-16). */
function tftJstNow() { return new Date(Date.now() + 9 * 3600000); }   /* read with getUTC* */
function tftTodayIso() { return tftJstNow().toISOString().slice(0, 10); }
function tftHourJst() { return tftJstNow().getUTCHours(); }
function tftAddDays(iso, n) {
  return new Date(Date.parse(iso + 'T00:00:00Z') + n * 86400000).toISOString().slice(0, 10);
}
function tftDaysBetween(fromIso, toIso) {
  return Math.round((Date.parse(toIso + 'T00:00:00Z') - Date.parse(fromIso + 'T00:00:00Z')) / 86400000);
}
function tftDow(iso) { return new Date(iso + 'T00:00:00Z').getUTCDay(); }

function initCal() {
  const today = tftTodayIso();
  calYear = Number(today.slice(0, 4));
  calMonth = Number(today.slice(5, 7)) - 1;
  renderCal();
}

function changeMonth(d) {
  let y = calYear, m = calMonth + d;
  if (m > 11) { m = 0; y++; }
  if (m < 0) { m = 11; y--; }
  // Never navigate past the month that holds the last bookable date, or
  // before the current month.
  const last = lastBookableDate();
  const today = tftTodayIso();
  const lastY = Number(last.slice(0, 4)), lastM = Number(last.slice(5, 7)) - 1;
  const nowY = Number(today.slice(0, 4)), nowM = Number(today.slice(5, 7)) - 1;
  const tooLate = y > lastY || (y === lastY && m > lastM);
  const tooEarly = y < nowY || (y === nowY && m < nowM);
  if (tooLate || tooEarly) return;
  calYear = y; calMonth = m;
  renderCal();
}

function isBlocked(date) {
  if (!date) return true;
  if (EXTRA_CLOSED.has(date)) return true;
  if (EXTRA_OPEN.has(date)) return false;
  const dow = tftDow(date);
  if (dow === 1 || dow === 2) return true;
  return false;
}

/* The day an order placed now counts from: today, or tomorrow after 17:00. */
function getEffectiveToday() {
  const today = tftTodayIso();
  return tftHourJst() >= 17 ? tftAddDays(today, 1) : today;
}

function isTooSoon(date) {
  return tftDaysBetween(getEffectiveToday(), date) < 3;
}

// Bookings open at most this many calendar months ahead (owner: 3 months on
// 2026-09-01, 4 months on 2026-09-21), same day of the month, clamped to a
// shorter month's last day. The server enforces the same window in
// save-reservation (_shared/availability.ts lastBookableDate); this only
// keeps the calendar honest so nobody picks a 2029 date and gets refused later.
// Counted from today, not from the 17:00-shifted day, because that is how the
// server counts it: after 17:00 the two used to differ by a day and the last
// date the calendar offered was refused (audit L-16).
const MAX_LEAD_MONTHS = 4;

function lastBookableDate() {
  const today = tftTodayIso();
  const y = Number(today.slice(0, 4)), m = Number(today.slice(5, 7)) - 1, d = Number(today.slice(8, 10));
  const lastDay = new Date(Date.UTC(y, m + MAX_LEAD_MONTHS + 1, 0)).getUTCDate();
  return new Date(Date.UTC(y, m + MAX_LEAD_MONTHS, Math.min(d, lastDay))).toISOString().slice(0, 10);
}

function isTooFar(date) {
  return date > lastBookableDate();
}

function renderCal() {
  const title = document.getElementById('month-title');
  title.textContent = `${calYear}年 ${calMonth + 1}月`;
  const grid = document.getElementById('cal-grid');
  grid.innerHTML = '';

  const notice = document.getElementById('date-notice');
  if (tftHourJst() >= 17) {
    notice.style.display = 'block';
    notice.textContent = '※ 17:00以降のご注文は翌日扱いとなります。最短受取日が1日後ろにずれます。';
  }

  const first = new Date(calYear, calMonth, 1).getDay();
  const last = new Date(calYear, calMonth + 1, 0).getDate();
  for (let i = 0; i < first; i++) {
    const el = document.createElement('div');
    el.className = 'date-btn disabled';
    el.innerHTML = '&nbsp;';
    grid.appendChild(el);
  }
  for (let d = 1; d <= last; d++) {
    const dateStr = `${calYear}-${String(calMonth+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
    const dow = new Date(calYear, calMonth, d).getDay();
    const btn = document.createElement('button');
    btn.className = 'date-btn';
    btn.textContent = d;
    const blocked = isBlocked(dateStr) || isTooSoon(dateStr) || isTooFar(dateStr);
    if (blocked) {
      btn.classList.add('disabled');
      if (isTooFar(dateStr)) btn.title = 'ご予約は4ヶ月先まで';
      else if (dow === 1 || dow === 2) btn.title = '定休日';
      else if (EXTRA_CLOSED.has(dateStr)) btn.title = '休業日';
    } else {
      if (dow === 0) btn.classList.add('sunday');
      if (dow === 6) btn.classList.add('saturday');
      if (sel.date === dateStr) btn.classList.add('selected');
      btn.onclick = () => selectDate(dateStr, btn);
    }
    grid.appendChild(btn);
  }
}

function selectDate(dateStr, btn) {
  sel.date = dateStr;
  document.querySelectorAll('.date-btn').forEach(b => b.classList.remove('selected'));
  btn.classList.add('selected');
  document.getElementById('btn1').disabled = false;
  const notice = document.getElementById('date-notice');
  notice.style.display = 'block';
  const days = ['日','月','火','水','木','金','土'];
  const dowLabel = days[tftDow(dateStr)];
  if (tftHourJst() >= 17) {
    notice.textContent = `※ 17:00以降のご注文は翌日扱いとなります。 ／ ${dateStr}（${dowLabel}）を選択しました`;
  } else {
    notice.textContent = `${dateStr}（${dowLabel}）を選択しました`;
  }
  updateSelBar();
}

// ===== 時間 =====
function renderTimeGrid() {
  const grid = document.getElementById('time-grid');
  grid.innerHTML = '';
  const times = [];
  for (let h = 10; h <= 18; h++) {
    times.push(`${h}:00`);
    if (h < 19) times.push(`${h}:30`);
  }
  times.push('19:00');
  times.forEach(t => {
    const btn = document.createElement('button');
    btn.className = 'time-btn';
    btn.textContent = t;
    if (sel.time === t) btn.classList.add('selected');
    btn.onclick = () => selectTime(t, btn);
    grid.appendChild(btn);
  });
}

function selectTime(t, btn) {
  sel.time = t;
  document.querySelectorAll('.time-btn').forEach(b => b.classList.remove('selected'));
  btn.classList.add('selected');
  document.getElementById('btn2').disabled = false;
  updateSelBar();
}

// ===== ケーキ価格テーブル =====
function renderCakeTable() {
  const wrap = document.getElementById('cake-table-wrap');
  const colHead = document.getElementById('cake-col-head');
  /* Selecting a price re-renders this whole table, which replaces the DOM and
     takes the horizontal scroll position with it — the customer was thrown
     back to the first column every time they picked a price. Hand the offset
     to the sizing script, which restores it once the columns are pinned. */
  if (wrap && colHead) {
    window.tftTableScrollX = { head: colHead.scrollLeft, body: wrap.scrollLeft };
  }
  const selDi = sel.cake && !sel.isSpecial && !sel.whole
    ? DECOS.findIndex(d => sel.cake.endsWith(' ' + d))
    : -1;

  const decoNames = ['いちご飾り', 'フルーツ飾り', 'マカロン飾り', '飾りなし'];
  const decoPhotos = [
    CDN+'col_ichigo.png',
    CDN+'col_fruits.png',
    CDN+'col_macaron.png',
    CDN+'col_nashi.png',
  ];

  let headHtml = `<span class="ch-photo ch-sz">ケーキ</span>`;
  headHtml += `<span class="ch-sz">サイズ</span>`;
  decoNames.forEach((name, i) => {
    const isColHead = (i === selDi && selDi >= 0);
    headHtml += `<span class="${isColHead ? 'col-hl-head' : ''}">
      <img src="${decoPhotos[i]}" alt="${name}" class="col-head-img">
      <span class="col-head-txt">${name}</span>
    </span>`;
  });
  colHead.innerHTML = headHtml;

  let html = '';
  CAKES.forEach(cake => {
    /* The name is wrapped so it can be held at the left edge while the
       table scrolls sideways; the banner itself spans the full width. */
    html += `<div class="cake-sec-head"><span class="cake-sec-name">${cake.name}</span></div>`;
    html += `<div class="cake-body">`;
    if (cake.photo) {
      html += `<div class="cake-photo-col"><img src="${cake.photo}" alt="${cake.name}" class="cake-big-photo"></div>`;
    }
    html += `<div class="cake-rows-col">`;
    cake.rows.forEach(row => {
      const rowKey = `${cake.name} ${row.size}`;
      const isRowSel = sel.cake && !sel.isSpecial && !sel.whole && sel.cake.startsWith(rowKey + ' ');
      const pax = SZ_PERSON[row.size] ? `<span class="sz-pax">${SZ_PERSON[row.size]}</span>` : '';
      html += `<div class="cake-row">`;
      html += `<div class="c-sz${isRowSel ? ' row-hl' : ''}">${row.size}${pax}</div>`;
      row.p.forEach((price, di) => {
        const isColHl = selDi === di;
        if (price === null) {
          let cls = 'c-pr c-na';
          if (isRowSel) cls += ' row-hl';
          if (isColHl) cls += ' col-hl';
          html += `<div class="${cls}">―</div>`;
        } else {
          const key = `${rowKey} ${DECOS[di]}`;
          const isSel = sel.cake === key && !sel.isSpecial && !sel.whole;
          let cls = 'c-pr';
          if (isSel) cls += ' c-sel';
          else { if (isRowSel) cls += ' row-hl'; if (isColHl) cls += ' col-hl'; }
          html += `<div class="${cls}" onclick="selectCell('${key}',${price})">${price.toLocaleString()}</div>`;
        }
      });
      html += `</div>`;
    });
    html += `</div></div>`;
  });
  wrap.innerHTML = html;
  renderWholeCakes();
}

function selectCell(key, price) {
  sel.cake = key; sel.price = price; sel.isSpecial = false; sel.whole = null;
  renderCakeTable();
  updateSelBar();
}

/* The whole cakes sit under the grid in a block of their own, outside
   #cake-table-wrap: the section's sizing script pins every .cake-body inside
   the table to the decoration columns, and these have no columns to pin to.
   The page body has no slot for them, so the block is created here. */
function renderWholeCakes() {
  const table = document.getElementById('cake-table-wrap');
  const head = document.getElementById('cake-col-head');
  if (!table) return;
  /* The decoration header row is sticky, and a sticky element holds on for
     as long as its parent lasts — step 3 as a whole — so it stayed pinned
     over the whole cakes. Wrapping the header and the table ends it there. */
  let scope = document.getElementById('cake-grid-scope');
  if (!scope && head && head.parentElement === table.parentElement) {
    scope = document.createElement('div');
    scope.id = 'cake-grid-scope';
    head.insertAdjacentElement('beforebegin', scope);
    scope.appendChild(head);
    scope.appendChild(table);
  }
  let box = document.getElementById('whole-cakes');
  if (!box) {
    box = document.createElement('div');
    box.id = 'whole-cakes';
    (scope || table).insertAdjacentElement('afterend', box);
  }
  const photos = window.TFT_WHOLE_CAKE_PHOTOS || {};
  let html = `<div class="wc-head"><span class="wc-title">ホールケーキ</span>`
    + `<span class="wc-note">飾りの選択はありません。サイズの金額をタップしてください</span></div>`;
  html += `<div class="wc-grid">`;
  WHOLE_CAKES.forEach((cake, ci) => {
    html += `<div class="wc-card">`;
    if (photos[cake.photo]) {
      html += `<img src="${photos[cake.photo]}" alt="${cake.name}" class="wc-photo" loading="lazy">`;
    }
    html += `<div class="wc-name">${cake.name}</div><div class="wc-sizes">`;
    cake.rows.forEach(([size, price]) => {
      const isSel = sel.whole && sel.whole.name === cake.name && sel.whole.size === size;
      const pax = SZ_PERSON[size] ? `<span class="wc-pax">${SZ_PERSON[size]}</span>` : '';
      html += `<button type="button" class="wc-size${isSel ? ' wc-sel' : ''}" onclick="selectWhole(${ci},'${size}')">`
        + `<span class="wc-sz">${size}${pax}</span><span class="wc-pr">${price.toLocaleString()}</span></button>`;
    });
    html += `</div></div>`;
  });
  html += `</div>`;
  box.innerHTML = html;
}

function selectWhole(ci, size) {
  const cake = WHOLE_CAKES[ci];
  const row = cake && cake.rows.find(r => r[0] === size);
  if (!row) return;
  sel.cake = `${cake.name} ${size}`; sel.price = row[1]; sel.isSpecial = false;
  sel.whole = { name: cake.name, size };
  renderCakeTable();
  updateSelBar();
}

function updateSelBar() {
  const bar = document.getElementById('sel-bar');
  const btn3 = document.getElementById('btn3');

  if (sel.date) {
    const d = new Date(sel.date);
    const days = ['日','月','火','水','木','金','土'];
    document.getElementById('si-date').textContent =
      `${d.getMonth()+1}/${d.getDate()}(${days[d.getDay()]})`;
    document.getElementById('chip-date').style.display = '';
    bar.classList.remove('hidden');
  } else {
    document.getElementById('chip-date').style.display = 'none';
  }

  if (sel.time) {
    document.getElementById('si-time').textContent = sel.time;
    document.getElementById('chip-time').style.display = '';
  } else {
    document.getElementById('chip-time').style.display = 'none';
  }

  if (sel.cake) {
    document.getElementById('si-cake').textContent = sel.cake;
    document.getElementById('chip-cake').style.display = '';
    if (!sel.isSpecial) {
      document.getElementById('si-price').textContent = '¥' + sel.price.toLocaleString();
      document.getElementById('chip-price').style.display = '';
    } else {
      document.getElementById('chip-price').style.display = 'none';
    }
    btn3.disabled = false;
  } else {
    document.getElementById('chip-cake').style.display = 'none';
    document.getElementById('chip-price').style.display = 'none';
    btn3.disabled = true;
  }
}

// ===== ナビ =====
/* Once the reservation has been recorded, the step tabs must not carry the
   customer back into the date/time pickers: the booking is already sent, and
   editing the form afterwards would not change it. */
let tftOrderComplete = false;

function goToTab(step) {
  if (tftOrderComplete) return;
  const tab = document.getElementById('tab' + step);
  if (tab && tab.classList.contains('done')) goTo(step);
}

function goTo(step) {
  if (tftOrderComplete) return;
  document.querySelectorAll('.section').forEach(s => s.classList.remove('active'));
  document.getElementById('s' + step).classList.add('active');
  for (let i = 1; i <= 7; i++) {
    const tab = document.getElementById('tab' + i);
    tab.classList.remove('active', 'done');
    if (i < step) tab.classList.add('done');
    else if (i === step) tab.classList.add('active');
  }
  ['btn1','btn2','btn3','btn4','btn5','btn6','btn-submit-bar'].forEach(id => {
    document.getElementById(id).style.display = 'none';
  });
  const stepBtnMap = {1:'btn1',2:'btn2',3:'btn3',4:'btn4',5:'btn5',6:'btn6',7:'btn-submit-bar'};
  if (stepBtnMap[step]) document.getElementById(stepBtnMap[step]).style.display = '';
  if (step === 3) renderCakeTable();
  /* Arriving at a gated step: set 次へ from the current state. */
  if (step === 4) updateStep4Bar();
  if (step === 5) updateStep5Bar();
  if (sel.date) document.getElementById('sel-bar').classList.remove('hidden');
  window.scrollTo(0, 0);
}

/* Full-width digits are easy to type on a Japanese keyboard, so count them as
   digits rather than rejecting the number for it. */
/* Full-width digits and dashes to ASCII: ０９０－１２３４ → 090-1234. */
function tftHalfWidthPhone(value) {
  return value
    .replace(/[０-９]/g, c => String.fromCharCode(c.charCodeAt(0) - 0xfee0))
    .replace(/[－ー‐―]/g, '-');
}

function tftDigitCount(value) {
  return value
    .replace(/[０-９]/g, c => String.fromCharCode(c.charCodeAt(0) - 0xfee0))
    .replace(/[^0-9]/g, '').length;
}

/* 姓 and 名 as two boxes (2026-09-30). Smaregi holds a member as lastName +
   firstName and requires both, and the one お名前 box sent 山田花子 up whole.
   The boxes live in the page body (Shopify admin → Pages), so they are
   rebuilt here: the page's #name becomes 姓 and a #given_name box joins it on
   a row of their own; phone and email share the old row. Other markup is left
   as it is, and the single box keeps working. */
function tftSplitNameField() {
  const familyEl = document.getElementById('name');
  if (!familyEl || document.getElementById('given_name')) return;
  const group = familyEl.closest('.form-group');
  const row = group && group.closest('.form-row');
  if (!group || !row || !row.parentNode) return;

  const givenGroup = group.cloneNode(true);
  const givenEl = givenGroup.querySelector('input');
  if (!givenEl) return;
  givenEl.id = 'given_name';
  givenEl.value = '';
  givenEl.placeholder = '例：花子';
  givenEl.autocomplete = 'given-name';
  familyEl.placeholder = '例：山田';
  familyEl.autocomplete = 'family-name';
  tftSetLabelText(group.querySelector('.form-label'), '姓 ');
  tftSetLabelText(givenGroup.querySelector('.form-label'), '名 ');

  const nameRow = document.createElement('div');
  nameRow.className = row.className;
  row.parentNode.insertBefore(nameRow, row);
  nameRow.appendChild(group);
  nameRow.appendChild(givenGroup);
  const emailGroup = document.getElementById('email')?.closest('.form-group');
  if (emailGroup && emailGroup.parentNode === row.parentNode) row.appendChild(emailGroup);

  familyEl.addEventListener('blur', () => tftSplitWholeName(familyEl, givenEl));
}

/* The label's own words, keeping its 必須 marker. */
function tftSetLabelText(label, text) {
  if (!label) return;
  const node = Array.from(label.childNodes).find(n => n.nodeType === 3 && n.nodeValue.trim());
  if (node) node.nodeValue = text;
}

/* 山田 花子 typed into 姓 alone is both names. */
function tftSplitWholeName(familyEl, givenEl) {
  if (!familyEl || !givenEl || givenEl.value.trim()) return;
  const parts = familyEl.value.trim().split(/\s+/);
  if (parts.length < 2) return;
  familyEl.value = parts[0];
  givenEl.value = parts.slice(1).join(' ');
}

/* One check for both the confirm step and the final submit, so the two can't
   drift apart. Returns the trimmed values, or null once it has told the
   customer what to fix and put the cursor there. */
function tftReadContact() {
  const fields = ['name', 'phone', 'email'].map(id => document.getElementById(id));
  const [nameEl, phoneEl, emailEl] = fields;
  const givenEl = document.getElementById('given_name');
  tftSplitWholeName(nameEl, givenEl);
  const family = nameEl ? nameEl.value.trim() : '';
  const given = givenEl ? givenEl.value.trim() : '';
  const name = [family, given].filter(Boolean).join(' ');
  /* A number typed with the IME on (０９０－…) is the same number: sent as
     ASCII so every layer that compares phones agrees (audit M-19). */
  const phone = phoneEl ? tftHalfWidthPhone(phoneEl.value.trim()) : '';
  const email = emailEl ? emailEl.value.trim() : '';

  const problem =
    !family ? [nameEl, givenEl ? '姓をご入力ください。' : 'お名前をご入力ください。'] :
    givenEl && !given ? [givenEl, '名をご入力ください。'] :
    !phone ? [phoneEl, 'お電話番号をご入力ください。'] :
    (tftDigitCount(phone) < 10 || tftDigitCount(phone) > 11)
      ? [phoneEl, 'お電話番号は数字10〜11桁でご入力ください。（例：0740-20-6529）'] :
    !email ? [emailEl, 'メールアドレスをご入力ください。'] :
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
      ? [emailEl, 'メールアドレスの形式でご入力ください。（例：tea@example.com）'] :
    null;

  if (problem) {
    alert(problem[1]);
    if (problem[0]) problem[0].focus();
    return null;
  }
  return { name, phone, email };
}

function goToConfirm() {
  const contact = tftReadContact();
  if (!contact) return;
  const { name, phone } = contact;

  const payment = document.querySelector('input[name=payment]:checked');
  if (!payment) { alert('お支払い方法を選択してください。'); return; }

  const opts = [];
  const ps = document.querySelector('input[name=plate]:checked');
  if (ps) opts.push('プレート：' + ps.value);
  tftExtraPlateLines().forEach(l => opts.push(l));
  if (tftOptLabel('opt_plate2')) opts.push(tftOptLabel('opt_plate2'));
  if (document.getElementById('opt_candle').checked) opts.push('ろうそく5本（無料）');
  if (tftOptLabel('opt_candle2')) opts.push(tftOptLabel('opt_candle2'));
  if (document.getElementById('opt_bag').checked) opts.push('ビニール袋');
  if (numberCandleDigits()) opts.push('ナンバーキャンドル「' + numberCandleDigits() + '」');
  if (tftOptLabel('opt_firework')) opts.push(tftOptLabel('opt_firework'));
  const msg = tftPlateMessage();
  const remarks = document.getElementById('remarks').value;
  const total = sel.price + calcExtra();

  const paymentLabel = payment.value === 'online' ? 'オンライン決済' : '来店時お支払い';

  const html = `
    <div class="crow"><span class="k">受取日</span><span class="v">${sel.date}</span></div>
    <div class="crow"><span class="k">お仕上げ時間</span><span class="v">${sel.time}</span></div>
    <div class="crow"><span class="k">ケーキ</span><span class="v">${sel.cake}</span></div>
    <div class="crow"><span class="k">金額（目安）</span><span class="v price">${sel.isSpecial ? '要確認' : '¥' + total.toLocaleString()}</span></div>
    ${opts.length ? `<div class="crow"><span class="k">オプション</span><span class="v">${opts.join('、')}</span></div>` : ''}
    ${msg ? `<div class="crow"><span class="k">メッセージ</span><span class="v">${msg}</span></div>` : ''}
    ${remarks ? `<div class="crow"><span class="k">ご要望</span><span class="v">${remarks}</span></div>` : ''}
    <div class="crow"><span class="k">お名前</span><span class="v">${name}</span></div>
    <div class="crow"><span class="k">お電話番号</span><span class="v">${phone}</span></div>
    ${document.getElementById('email').value ? `<div class="crow"><span class="k">メール</span><span class="v">${document.getElementById('email').value}</span></div>` : ''}
    <div class="crow"><span class="k">お支払い方法</span><span class="v">${paymentLabel}</span></div>
  `;
  document.getElementById('confirm-box').innerHTML = html;
  goTo(7);
}

async function submitForm() {
  const contact = tftReadContact();
  if (!contact) return;
  const { name, phone, email } = contact;

  const payment = document.querySelector('input[name=payment]:checked');
  if (!payment) { alert('お支払い方法を選択してください。'); return; }

  /* The calendar could not be read when the page opened: the dates it
     offered came from a stale fallback, so nothing is sent on their
     strength. One more try, then the customer is told (audit M-29). */
  if (!tftCalendarLoaded) await fetchCalendarDates();
  if (!tftCalendarLoaded) {
    alert('カレンダーの情報を読み込めませんでした。ページを再読み込みしてからもう一度お試しください。');
    return;
  }
  /* A page left open past 17:00 or overnight can hold a date the rules no
     longer allow; the server would refuse it, so say so here first. */
  if (isBlocked(sel.date) || isTooSoon(sel.date) || isTooFar(sel.date)) {
    alert('選択された受取日はご予約いただけなくなりました。別の日をお選びください。');
    renderCal();
    goTo(1);
    return;
  }

  const btn = document.getElementById('btn-submit-bar');
  btn.disabled = true;
  btn.textContent = '送信中...';

  let cakeType = null, size = null, deco = null;
  if (sel.whole) {
    cakeType = sel.whole.name;
    size = sel.whole.size;
  } else for (const cake of CAKES) {
    if (sel.cake && sel.cake.startsWith(cake.name)) {
      cakeType = cake.name;
      const rest = sel.cake.slice(cake.name.length + 1);
      for (const sz of Object.keys(SZ_TO_SHOPIFY)) {
        if (rest.startsWith(sz + ' ')) {
          size = sz;
          deco = rest.slice(sz.length + 1);
          break;
        }
      }
      break;
    }
  }

  // A whole cake has no decoration; every other cake needs one.
  if (!cakeType || !size || (!deco && !sel.whole)) {
    alert('ケーキの選択をご確認ください。');
    btn.disabled = false;
    btn.textContent = '予約を送信する';
    return;
  }

  const ps = document.querySelector('input[name=plate]:checked');
  const extraPlate = document.getElementById('opt_plate2').checked;
  const candles = document.getElementById('opt_candle').checked;
  const extraCandles = document.getElementById('opt_candle2').checked;
  const vinylBag = document.getElementById('opt_bag').checked;
  const numberCandle = numberCandleDigits();
  const firework = fireworkChecked();
  const total = sel.price + calcExtra();

  const supabasePayload = {
    pickup_date: sel.date,
    pickup_time: sel.time,
    cake_type: cakeType,
    cake_size: size,
    decoration: deco,
    price: sel.price,
    total_price: total,
    plate_shape: ps ? ps.value : null,
    extra_plate: extraPlate,
    candles: candles,
    extra_candles: extraCandles,
    vinyl_bag: vinylBag,
    number_candle: numberCandle || null,
    firework: firework,
    /* How many of each, beside the yes/no the dashboard has always read.
       The cart already charges by the count and the customer already chose
       one, but the booking itself only ever said 追加プレート, so three
       plates reached the kitchen, the slip and the register sale as one.
       Both routes take this object — the in-store POST and the hidden
       line-item property the order webhook builds from — so the count
       arrives whichever way the customer pays. */
    extra_plate_qty: tftOptQty('opt_plate2'),
    extra_candles_qty: tftOptQty('opt_candle2'),
    vinyl_bag_qty: vinylBag ? 1 : 0,
    firework_qty: tftOptQty('opt_firework'),
    /* Plates 2+ with their own shape and message, as data (2026-09-27). */
    extra_plates: tftExtraPlatesData(),
    plate_message: tftPlateMessage().slice(0, 200) || null,
    remarks: tftRemarksOut(),
    client_request_id: tftRequestId,
    customer_name: name,
    customer_phone: phone,
    customer_email: email,
    status: 'pending',
    smaregi_status: 'pending',
    payment_method: payment.value,
    payment_status: 'unpaid',
  };

  // 来店時お支払い: no Shopify order happens — save the reservation directly.
  // オンライン決済: save NOTHING here; the reservation is created by the
  // orders/create webhook when the checkout actually completes, so abandoned
  // checkouts never reach the dashboard.
  if (payment.value === 'instore') {
    try {
      await saveToSupabase(supabasePayload);
    } catch (e) {
      console.error('Supabase error:', e);
      alert(tftSaveErrorText(e));
      btn.disabled = false;
      btn.textContent = '予約を送信する';
      return;
    }
    tftRequestId = tftNewRequestId();
    tftOrderComplete = true;
    document.querySelectorAll('.section').forEach(s => s.classList.remove('active'));
    document.getElementById('s-done').classList.add('active');
    document.getElementById('sel-bar').classList.add('hidden');
    /* Retire the step bar. Clearing `done` is what actually stops goToTab;
       hiding the row stops it inviting the click in the first place. */
    for (let i = 1; i <= 7; i++) {
      const t = document.getElementById('tab' + i);
      if (!t) continue;
      t.classList.remove('active', 'done');
      t.style.pointerEvents = 'none';
    }
    const firstTab = document.getElementById('tab1');
    if (firstTab && firstTab.parentElement) firstTab.parentElement.style.display = 'none';
    window.scrollTo(0, 0);
    return;
  }

  const variantId = sel.whole
    ? wholeVariantMap[`${cakeType}|${SZ_TO_SHOPIFY[size]}`]
    : variantMap[`${cakeType}|${SZ_TO_SHOPIFY[size]}|${deco}`];
  if (!variantId) {
    alert('この組み合わせは現在受け付けておりません。');
    btn.disabled = false;
    btn.textContent = '予約を送信する';
    return;
  }

  const opts = [];
  tftExtraPlateLines().forEach(l => opts.push(l));
  if (tftOptLabel('opt_plate2')) opts.push(tftOptLabel('opt_plate2'));
  if (candles) opts.push('ろうそく5本');
  if (tftOptLabel('opt_candle2')) opts.push(tftOptLabel('opt_candle2'));
  if (vinylBag) opts.push('ビニール袋');
  if (numberCandle) opts.push('ナンバーキャンドル「' + numberCandle + '」');
  if (tftOptLabel('opt_firework')) opts.push(tftOptLabel('opt_firework'));

  const props = {
    '受取日': sel.date,
    'お仕上げ時間': sel.time,
    'プレート形状': ps ? ps.value : '未選択',
    'メッセージ': tftPlateMessage() || '（なし）',
    'その他ご要望': document.getElementById('remarks').value || '（なし）',
    'お名前': name,
    'お電話番号': phone,
    'お支払い方法': 'オンライン決済',
  };
  if (document.getElementById('email').value) props['メール'] = document.getElementById('email').value;
  if (opts.length) props['追加オプション'] = opts.join('、');
  // Hidden property (leading underscore): the webhook builds the dashboard
  // reservation from this once the order exists.
  props['_reservation_payload'] = JSON.stringify(supabasePayload);

  // The cake, then one line per priced add-on. A chosen add-on whose
  // variant is unknown (the options product failed to load) must not slip
  // through as a free one: stop here rather than undercharge.
  const items = [{ id: variantId, quantity: 1, properties: props }];
  // [sku, quantity]: the number candle is one line, a candle per digit.
  const chosen = [];
  if (extraPlate) chosen.push([ADDON_SKU.plate, tftOptQty('opt_plate2')]);
  if (extraCandles) chosen.push([ADDON_SKU.candles, tftOptQty('opt_candle2')]);
  if (vinylBag) chosen.push([ADDON_SKU.bag, 1]);
  if (numberCandle) chosen.push([ADDON_SKU.numberCandle, numberCandle.length]);
  if (firework) chosen.push([ADDON_SKU.firework, tftOptQty('opt_firework')]);
  for (const [sku, qty] of chosen) {
    if (!addonMap[sku]) {
      alert('オプションの読み込みに失敗しました。ページを再読み込みしてからもう一度お試しください。');
      btn.disabled = false;
      btn.textContent = '予約を送信する';
      return;
    }
    items.push({ id: addonMap[sku], quantity: qty, properties: { '_reservation_addon': sku, 'ご予約': `${name} 様 ${sel.date}` } });
  }

  try {
    // One reservation = one checkout: drop anything left in the cart from an
    // earlier abandoned attempt before adding this cake.
    await fetch('/cart/clear.js', { method: 'POST' });
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (r.ok) {
      window.location.href = '/checkout';
    } else {
      // Surface the real failure: cart errors are JSON, but a redirect to the
      // password page or a bot challenge returns HTML, which used to crash the
      // JSON parse here and hide everything behind a generic message.
      let msg = 'HTTP ' + r.status;
      try {
        const e = await r.json();
        msg = e.description || e.message || msg;
      } catch (_) { /* non-JSON response: keep the status code */ }
      alert('エラー: ' + msg);
      btn.disabled = false;
      btn.textContent = '予約を送信する';
    }
  } catch(e) {
    alert('通信エラーが発生しました。もう一度お試しください。 (' + (e && e.message ? e.message : e) + ')');
    btn.disabled = false;
    btn.textContent = '予約を送信する';
  }
}

// ===== STEP4・5 フッター更新 =====
/* ナンバーキャンドル and 花火 (2026-09-24). The options markup lives in the
   page body, so these two rows are added here, after ビニール袋. The number
   candle is the digits the customer wants — one ¥110 candle per digit, so
   "25" is ¥220; full-width digits count, anything else is dropped. Mirror of
   supabase/functions/_shared/cake-extras.ts. */
const NUMBER_CANDLE_PRICE = 110;
const FIREWORK_PRICE = 110;

function numberCandleDigits() {
  const el = document.getElementById('opt_numcandle');
  if (!el) return '';
  /* The tick box is the decision; the number is what is ordered. Unticked
     means none, whatever is left in the field. */
  const on = document.getElementById('opt_numcandle_on');
  if (on && !on.checked) return '';
  return el.value
    .replace(/[０-９]/g, c => String.fromCharCode(c.charCodeAt(0) - 0xfee0))
    .replace(/[^0-9]/g, '')
    .slice(0, 3);
}

function fireworkChecked() {
  const el = document.getElementById('opt_firework');
  return !!(el && el.checked);
}

function addExtraOptionRows() {
  const bag = document.getElementById('opt_bag');
  const bagRow = bag && bag.closest('.opt-row');
  if (!bagRow || document.getElementById('opt_numcandle')) return;
  bagRow.insertAdjacentHTML('afterend',
    /* ナンバーキャンドル gets a tick box like every other option (shop,
       2026-09-24): a bare number field read as something that had to be
       filled in. */
    '<div class="opt-row">'
    + '<input id="opt_numcandle_on" type="checkbox"><label for="opt_numcandle_on">ナンバーキャンドル</label>'
    + '<input id="opt_numcandle" class="form-input opt-num" type="text" inputmode="numeric" maxlength="3" placeholder="例：25" autocomplete="off">'
    + '<span class="pnote">数字1つ +110円</span>'
    + '</div>'
    + '<div class="opt-row">'
    + '<input id="opt_firework" type="checkbox"><label for="opt_firework">花火（1セット 3本）</label><span class="pnote">+110円</span>'
    + '</div>');

  /* Keep the two in step: unticking clears the number, typing one ticks it. */
  const on = document.getElementById('opt_numcandle_on');
  const num = document.getElementById('opt_numcandle');
  if (on && num) {
    on.addEventListener('change', function () {
      if (!on.checked) num.value = '';
      updateStep4Bar();
    });
    num.addEventListener('input', function () {
      if (num.value.trim()) on.checked = true;
      updateStep4Bar();
    });
  }
}

/* 追加プレート and 追加ろうそく are ordered by the piece — some customers want
   several (shop, 2026-09-24). Ticked with no box yet means one, which is how
   they behaved before. Prices are tax-inclusive, like the rest. */
const TFT_QTY_OPTS = [
  { id: 'opt_plate2',  label: '追加プレート',   price: 100 },
  { id: 'opt_candle2', label: '追加ろうそく5本', price: 55 },
  /* One firework is a set of three sticks, which the label has to say — a
     customer wanting three came away with three sets (shop, 2026-09-25). */
  { id: 'opt_firework', label: '花火（1セット 3本）', price: FIREWORK_PRICE },
];
const TFT_QTY_MAX = 20;

function tftOptQty(id) {
  const box = document.getElementById(id);
  if (!box || !box.checked) return 0;
  const q = document.getElementById('tft_qty_' + id);
  if (!q) return 1;
  const n = parseInt(q.value, 10);
  return isNaN(n) || n < 1 ? 1 : Math.min(n, TFT_QTY_MAX);
}

/* "追加プレート×3", or null when not chosen. */
function tftOptLabel(id) {
  const o = TFT_QTY_OPTS.filter(x => x.id === id)[0];
  const n = tftOptQty(id);
  return n ? o.label + '×' + n : null;
}

/* A number box beside each of the two, built here because the option markup
   lives in the Shopify page body. */
function tftBuildQtyBoxes() {
  TFT_QTY_OPTS.forEach(o => {
    if (document.getElementById('tft_qty_' + o.id)) return;
    const box = document.getElementById(o.id);
    if (!box) return;
    const row = box.closest('.opt-row, label, li') || box.parentElement;
    if (!row) return;
    const wrap = document.createElement('span');
    wrap.className = 'tft-addon-qty';
    const input = document.createElement('input');
    input.type = 'number';
    input.id = 'tft_qty_' + o.id;
    input.min = '1';
    input.max = String(TFT_QTY_MAX);
    input.value = '1';
    input.inputMode = 'numeric';
    input.setAttribute('aria-label', o.label + 'の個数');
    const unit = document.createElement('span');
    unit.className = 'tft-addon-unit';
    unit.textContent = '個';
    wrap.appendChild(input);
    wrap.appendChild(unit);
    row.appendChild(wrap);
    const sync = () => {
      if (!box.checked && document.activeElement === input) box.checked = true;
      updateStep4Bar();
      tftSyncPlates();
    };
    input.addEventListener('input', sync);
    input.addEventListener('change', sync);
    input.addEventListener('click', e => e.stopPropagation());
  });
}

function calcExtra() {
  let extra = 0;
  TFT_QTY_OPTS.forEach(o => { extra += o.price * tftOptQty(o.id); });
  if (document.getElementById('opt_bag').checked) extra += 10;
  extra += numberCandleDigits().length * NUMBER_CANDLE_PRICE;
  return extra;
}

/* Ticked but empty: the customer has asked for a number candle without
 saying which number. The order cannot be made from that, and it used to
 reach the shop as a blank (shop, 2026-09-25). */
function numberCandleIncomplete() {
  const on = document.getElementById('opt_numcandle_on');
  return !!(on && on.checked && !numberCandleDigits());
}

function updateStep4Bar() {
  /* 次へ waits for the digits, the same way the plate step waits for its
     shape and message. */
  const btn4 = document.getElementById('btn4');
  if (btn4) btn4.disabled = numberCandleIncomplete();

  const ps = document.querySelector('input[name=plate]:checked');
  const chipPlate = document.getElementById('chip-plate');
  if (ps) {
    document.getElementById('si-plate').textContent = ps.value;
    chipPlate.style.display = '';
  } else {
    chipPlate.style.display = 'none';
  }
  const opts = [];
  if (tftOptLabel('opt_plate2')) opts.push(tftOptLabel('opt_plate2'));
  if (document.getElementById('opt_candle').checked) opts.push('ろうそく5本');
  if (tftOptLabel('opt_candle2')) opts.push(tftOptLabel('opt_candle2'));
  if (document.getElementById('opt_bag').checked) opts.push('ビニール袋');
  if (numberCandleDigits()) opts.push('ナンバーキャンドル「' + numberCandleDigits() + '」');
  if (tftOptLabel('opt_firework')) opts.push(tftOptLabel('opt_firework'));
  const chipOpts = document.getElementById('chip-opts');
  if (opts.length) {
    document.getElementById('si-opts').textContent = opts.join('・');
    chipOpts.style.display = '';
  } else {
    chipOpts.style.display = 'none';
  }
  if (sel.price && !sel.isSpecial) {
    document.getElementById('si-price').textContent = '¥' + (sel.price + calcExtra()).toLocaleString();
    document.getElementById('chip-price').style.display = '';
  }
}

function updateStep5Bar() {
  /* Every plate needs a shape and a message, so 次へ stays disabled until
     they are filled in — the same way the other steps gate their button.
     プレートなし has nothing to write on: its message box is switched off
     (what was typed stays, in case the customer picks a shape again). */
  const btn5 = document.getElementById('btn5');
  if (btn5) btn5.disabled = !!tftPlateProblem();
  const msgEl = document.getElementById('msg');
  if (msgEl) {
    // The theme styles the box the same when disabled; fade it so it reads off.
    msgEl.disabled = tftNoPlate();
    msgEl.style.opacity = msgEl.disabled ? '0.4' : '';
  }

  const msg = tftPlateMessage().trim();
  const chipMsg = document.getElementById('chip-msg');
  if (msg) {
    document.getElementById('si-msg').textContent = msg;
    chipMsg.style.display = '';
  } else {
    chipMsg.style.display = 'none';
  }
}

// ===== Shopify連携 =====
let variantMap = {};
// The whole cakes' product: two options, ケーキ種類 and サイズ.
let wholeVariantMap = {};
// The add-ons (追加プレート・追加ろうそく・ビニール袋) are their own Shopify
// product, one variant per add-on, keyed by SKU. Until 2026-09-21 the wizard
// put the cake alone in the cart and the add-on money lived only in the
// hidden payload — step 7 showed the right total, the checkout charged the
// cake alone. Each chosen add-on is now a line of its own, so the checkout
// total is the confirmation total.
let addonMap = {};
const ADDON_SKU = {
  plate: 'EXTRA-PLATE', candles: 'EXTRA-CANDLE', bag: 'EXTRA-BAG',
  numberCandle: 'NUMBER-CANDLE', firework: 'FIREWORK',
};

async function fetchVariants() {
  const [cake, addons, whole] = await Promise.allSettled([
    fetch('/products/decoration-cake.json').then(r => r.json()),
    fetch('/products/decoration-cake-options.json').then(r => r.json()),
    fetch('/products/whole-cake.json').then(r => r.json()),
  ]);
  if (whole.status === 'fulfilled') {
    whole.value.product.variants.forEach(v => {
      wholeVariantMap[`${v.option1}|${v.option2}`] = v.id;
    });
  } else {
    console.warn('ホールケーキ取得失敗', whole.reason);
  }
  if (cake.status === 'fulfilled') {
    cake.value.product.variants.forEach(v => {
      variantMap[`${v.option1}|${v.option2}|${v.option3}`] = v.id;
    });
  } else {
    console.warn('バリアント取得失敗', cake.reason);
  }
  if (addons.status === 'fulfilled') {
    addons.value.product.variants.forEach(v => { if (v.sku) addonMap[v.sku] = v.id; });
  } else {
    console.warn('オプション取得失敗', addons.reason);
  }
}

const SZ_TO_SHOPIFY = {
  '4号': '4号（2〜4名）', '5号': '5号（4〜6名）',
  '6号': '6号（6〜8名）', '7号': '7号（8〜10名）'
};

/* ===== プレート（形状＋メッセージ） ==========================================
   追加プレート is a plate of its own: it needs its own shape and its own
   message, which the form had no way to ask for. So the shape chooser moves
   out of 追加オプション down to the message step, where it sits above the
   message it belongs to, and one more shape + message pair appears for every
   extra plate ordered.

   The page body owns the original markup, so the extra pairs are cloned from
   it and inherit the form's own styling. Plate 1 keeps the original #msg and
   input[name=plate], so everything that already reads those keeps working. */

function tftPlateCount() {
  return 1 + tftOptQty('opt_plate2');
}

/* The plate-shape chooser, found by what is inside it rather than by its
 class. The page body uses .shape-grid for more than one set of radios — the
 payment method is one — so matching on the class alone picked up the wrong
 box and, worse, let the sweep below delete it. The plate radios are the
 thing that makes this grid the plate grid. */
function tftShapeGrid() {
  const radio = document.querySelector('input[name="plate"]');
  if (!radio) return null;
  return (radio.closest && radio.closest('.shape-grid')) ||
         (radio.closest && radio.closest('.opt-row, .form-row, fieldset, div')) ||
         radio.parentElement;
}

/* The shape a customer picks when they want no plate on the cake. Only the
   free plate offers it; an extra plate is one they chose to pay for. */
const TFT_NO_PLATE = 'プレートなし';

function tftNoPlate() {
  const ps = document.querySelector('input[name=plate]:checked');
  return !!ps && ps.value === TFT_NO_PLATE;
}

/* The free plate's message as it is sent: nothing when there is no plate,
   whatever is still in the (switched-off) box. */
function tftPlateMessage() {
  const msg = document.getElementById('msg');
  return tftNoPlate() || !msg ? '' : msg.value;
}

/* Shape + message of one plate. Index 1 is the plate that comes free. */
function tftPlateAt(i) {
  if (i === 1) {
    const ps = document.querySelector('input[name=plate]:checked');
    return { shape: ps ? ps.value : null, message: tftPlateMessage().trim() };
  }
  const ps = document.querySelector('input[name=tft_plate_' + i + ']:checked');
  const msg = document.getElementById('tft_msg_' + i);
  return { shape: ps ? ps.value : null, message: msg ? msg.value.trim() : '' };
}

/* Every plate needs a shape and a message before 次へ opens — except
   プレートなし, which needs neither a message nor anything else. Returns the
   first thing missing, or null when they are all filled in. */
function tftPlateProblem() {
  for (let i = 1; i <= tftPlateCount(); i++) {
    const pl = tftPlateAt(i);
    const who = i === 1 ? 'プレート1（無料分）' : 'プレート' + i + '（追加分）';
    if (!pl.shape) return who + 'の形状をお選びください。';
    if (pl.shape === TFT_NO_PLATE) continue;
    if (!pl.message) return who + 'のメッセージをご入力ください。';
  }
  return null;
}

/* Plates 2+ as readable lines: プレート2：くまさん／Happy Birthday */
function tftExtraPlateLines() {
  const out = [];
  for (let i = 2; i <= tftPlateCount(); i++) {
    const pl = tftPlateAt(i);
    if (!pl.shape && !pl.message) continue;
    out.push('プレート' + i + '：' + (pl.shape || '形状未選択') +
             (pl.message ? '／' + pl.message : ''));
  }
  return out;
}

/* What the customer wrote, and nothing else — 300 characters at most (D-9).
   The add-on counts and the extra plates travel as their own fields
   (extra_*_qty, extra_plates); until 2026-09-27 they were appended here as
   【追加オプション】／【追加プレート】 lines, which the customer then saw inside
   ご要望 in their own email and staff saw twice (audit M-23). */
function tftRemarksOut() {
  const own = document.getElementById('remarks').value.trim();
  return own ? own.slice(0, 300) : null;
}

/* Plates 2+ as data: one {shape, message} per extra plate, in order. */
function tftExtraPlatesData() {
  const out = [];
  for (let i = 2; i <= tftPlateCount(); i++) {
    const pl = tftPlateAt(i);
    out.push({ shape: pl.shape || null, message: pl.message ? pl.message.slice(0, 200) : null });
  }
  return out;
}

/* Whatever is left in 追加オプション still announcing the plate shape.

   Three attempts at guessing that markup — the heading as the grid's previous
   sibling, the heading inside an .opt-row, an element whose whole text is the
   heading — all left the words on the page, so this stops guessing at shape.
   It looks for the words themselves in text nodes, which is the one thing
   every possible markup has in common, takes just those words out, and then
   drops the wrappers that the removal left empty. Our own plate blocks are
   skipped so the chooser we just moved is never touched. */
const TFT_SHAPE_HEAD =
  /プレート\s*(?:の)?\s*形状(?:\s*[（(][^）)]*[）)])?[\s:：*＊]*/g;

/* Where the plate markup used to sit. Emptiness is re-checked on every pass,
   because the form re-renders its steps and can put a box back. */
let tftPlateHomes = [];

function tftStripShapeHeading(alsoEmpty) {
  /* Only once the chooser has a home of its own — stripping the heading while
     the grid is still in 追加オプション would leave it there unlabelled. */
  if (!document.getElementById('tft-plate-1')) return;
  const root = document.querySelector('.tft') || document.body;
  if (!root || !document.createTreeWalker) return;

  const hits = [];
  const walk = document.createTreeWalker(root, 4 /* SHOW_TEXT */, null);
  let node;
  while ((node = walk.nextNode())) {
    TFT_SHAPE_HEAD.lastIndex = 0;
    if (!TFT_SHAPE_HEAD.test(node.data || '')) continue;
    const owner = node.parentElement;
    if (!owner || (owner.closest && owner.closest('.tft-plate-block'))) continue;
    hits.push(node);
  }

  const spent = hits.map(function (n) {
    const owner = n.parentElement;
    TFT_SHAPE_HEAD.lastIndex = 0;
    n.data = (n.data || '').replace(TFT_SHAPE_HEAD, '');
    return owner;
  });

  /* An element that held nothing but the heading would otherwise stay as an
     empty bordered row, so it goes too — and so does its wrapper, as far up
     as the emptiness reaches. Anything with a control, a picture or words of
     its own stops the climb. */
  spent.concat(tftPlateHomes, alsoEmpty || []).forEach(function (start) {
    let el = start;
    for (let depth = 0; el && depth < 6; depth++) {
      const up = el.parentElement;
      if (!up || el === root || el === document.body) break;
      if (el.classList && el.classList.contains('tft-plate-block')) break;
      if (el.querySelector('input, select, textarea, button, img, a, .shape-grid')) break;
      if ((el.textContent || '').trim()) break;
      up.removeChild(el);
      el = up;
    }
  });
}

/* The form swaps its markup between steps, so 追加オプション can come back with
   a fresh copy of the chooser after ours has already moved. A second grid
   would show a stray set of shapes and share input[name=plate] with plate 1,
   so the copy goes and its wrapper goes with it. */
function tftDropStrayGrids() {
  if (!document.getElementById('tft-plate-1')) return;
  const strays = [];
  /* Only a box holding the plate radios is a stray copy of the chooser.
     Keyed off the class alone this took the payment method chooser with it
     (2026-09-25) — it shares the class, and the form was left with no way to
     choose how to pay. */
  document.querySelectorAll('.shape-grid').forEach(function (g) {
    if (g.closest && g.closest('.tft-plate-block')) return;
    if (!g.querySelector('input[name="plate"]')) return;
    strays.push(g);
  });
  strays.forEach(function (g) {
    const home = g.parentElement;
    if (home) { home.removeChild(g); tftPlateHomes.push(home); }
  });
}

function tftMoveShapeChooser() {
  const grid = tftShapeGrid();
  const msg = document.getElementById('msg');
  if (!grid || !msg || document.getElementById('tft-plate-1')) return;

  const host = document.createElement('div');
  host.id = 'tft-plate-1';
  host.className = 'tft-plate-block';
  const head = document.createElement('p');
  head.className = 'tft-plate-head';
  head.textContent = 'プレート1（無料分）';
  host.appendChild(head);

  const anchor = msg.closest('.opt-row, .form-row, label, div') || msg;
  anchor.parentNode.insertBefore(host, anchor);

  /* Nothing about the plate stays behind in 追加オプション.

     Earlier attempts keyed off the heading being the grid's previous sibling
     and sitting in an .opt-row, and the heading survived — the page body does
     not lay it out that way. So the grid is moved first, and then whatever is
     left over is found by what it says: any element in the options area whose
     whole text is the 形状 heading and which holds no controls of its own. Its
     wrapper goes too once it is empty, otherwise an empty bordered row is left
     behind. */
  const origParent = grid.parentElement;
  host.appendChild(grid);
  tftPlateHomes = [origParent];
  tftStripShapeHeading();
  const guide = document.getElementById('tft-plate-guide');
  if (guide) host.appendChild(guide);
  host.appendChild(anchor);
}

function tftBuildPlate(i) {
  if (document.getElementById('tft-plate-' + i)) return;
  const grid = tftShapeGrid();
  const msg = document.getElementById('msg');
  const first = document.getElementById('tft-plate-1');
  if (!grid || !msg || !first) return;

  const host = document.createElement('div');
  host.id = 'tft-plate-' + i;
  host.className = 'tft-plate-block';
  const head = document.createElement('p');
  head.className = 'tft-plate-head';
  head.textContent = 'プレート' + i + '（追加分）';
  host.appendChild(head);

  const copy = grid.cloneNode(true);
  copy.removeAttribute('id');
  /* An extra plate is one the customer pays for: プレートなし makes no sense
     there, and would let it through without a message. */
  copy.querySelectorAll('input').forEach(input => {
    if (input.value === TFT_NO_PLATE) (input.closest('label') || input).remove();
  });
  copy.querySelectorAll('input').forEach(input => {
    const was = input.id;
    input.name = 'tft_plate_' + i;
    input.id = (was || 'plate') + '_p' + i;
    input.checked = false;
    input.removeAttribute('checked');
    if (was) {
      const lbl = copy.querySelector('label[for="' + was + '"]');
      if (lbl) lbl.setAttribute('for', input.id);
    }
    input.addEventListener('change', updateStep5Bar);
  });
  host.appendChild(copy);

  const msgCopy = msg.cloneNode(false);
  msgCopy.id = 'tft_msg_' + i;
  msgCopy.name = 'tft_msg_' + i;
  msgCopy.value = '';
  msgCopy.maxLength = 200;
  msgCopy.setAttribute('placeholder', 'プレート' + i + 'のメッセージ');
  msgCopy.addEventListener('input', updateStep5Bar);
  host.appendChild(msgCopy);

  /* After the last block there is, not after plate 1 — inserting each new one
     straight after the first put them on the page backwards (1, 3, 2). */
  let after = first;
  for (let k = 2; k < i; k++) {
    const prev = document.getElementById('tft-plate-' + k);
    if (prev) after = prev;
  }
  after.parentNode.insertBefore(host, after.nextSibling);
}

/* Keep the blocks equal to the plates ordered. Blocks only ever drop from the
   end, so what was typed into the earlier ones survives a change of quantity. */
function tftSyncPlates() {
  tftMoveShapeChooser();
  tftDropStrayGrids();
  tftStripShapeHeading();
  const want = tftPlateCount();
  for (let i = 2; i <= want; i++) tftBuildPlate(i);
  for (let i = want + 1; ; i++) {
    const extra = document.getElementById('tft-plate-' + i);
    if (!extra) break;
    extra.parentNode.removeChild(extra);
  }
  updateStep5Bar();
}

// ===== 初期化 =====
async function tftInit() {
  // Before anything waits on the network: the customer never sees one box.
  tftSplitNameField();
  // Fetch calendar dates from Supabase before rendering calendar
  await fetchCalendarDates();

  /* The requests box takes 300 characters and a plate message 200 — the
     server's limits (D-9), applied here so nothing is cut on the way. */
  const remarksEl = document.getElementById('remarks');
  if (remarksEl) remarksEl.maxLength = 300;
  const msgEl = document.getElementById('msg');
  if (msgEl) msgEl.maxLength = 200;

  initCal();
  renderTimeGrid();
  addExtraOptionRows();
  tftBuildQtyBoxes();
  tftSyncPlates();
  fetchVariants();

  // Calendar navigation
  const calBtns = document.querySelectorAll('.cal-nav button');
  if (calBtns[0]) calBtns[0].onclick = () => changeMonth(-1);
  if (calBtns[1]) calBtns[1].onclick = () => changeMonth(1);

  // Back buttons
  const backBtns = document.querySelectorAll('.btn-back');
  if (backBtns[0]) backBtns[0].onclick = () => goTo(1);
  if (backBtns[1]) backBtns[1].onclick = () => goTo(2);
  if (backBtns[2]) backBtns[2].onclick = () => goTo(3);
  if (backBtns[3]) backBtns[3].onclick = () => goTo(4);
  if (backBtns[4]) backBtns[4].onclick = () => goTo(5);
  if (backBtns[5]) backBtns[5].onclick = () => goTo(6);

  // Next buttons
  document.getElementById('btn1').onclick = () => goTo(2);
  document.getElementById('btn2').onclick = () => goTo(3);
  document.getElementById('btn3').onclick = () => goTo(4);
  document.getElementById('btn4').onclick = () => goTo(5);
  document.getElementById('btn5').onclick = () => goTo(6);
  document.getElementById('btn6').onclick = () => goToConfirm();
  document.getElementById('btn-submit-bar').onclick = () => submitForm();

  // Step tabs
  for (let i = 1; i <= 7; i++) {
    const tab = document.getElementById('tab' + i);
    if (tab) tab.onclick = () => goToTab(i);
  }

  // Options
  /* The free plate's shapes sit on step 5 since the chooser moved there, so a
     change must re-check that step's 次へ too — before this, a message typed
     first and a shape picked after left 次へ disabled until the next keystroke. */
  document.querySelectorAll('input[name=plate]').forEach(r =>
    r.addEventListener('change', () => { updateStep4Bar(); updateStep5Bar(); })
  );
  addExtraOptionRows();
  /* Ticking 追加プレート already means one — the number box starts at 1 and
     nobody has to touch it. The plate blocks were only rebuilt when that box
     changed, so a customer who just ticked the option was never asked what to
     write on the plate they had ordered (shop, 2026-09-25). */
  ['opt_plate2','opt_candle','opt_candle2','opt_bag','opt_firework'].forEach(id => {
    const el = document.getElementById(id);
    if (!el) return;
    el.addEventListener('change', () => {
      updateStep4Bar();
      tftSyncPlates();
    });
  });
  const numCandle = document.getElementById('opt_numcandle');
  if (numCandle) numCandle.addEventListener('input', updateStep4Bar);
  document.getElementById('msg').addEventListener('input', updateStep5Bar);

  document.querySelectorAll('.form-input, .form-textarea').forEach(el => {
    el.addEventListener('focus', () => {
      document.getElementById('sel-bar').classList.add('hidden');
    });
    el.addEventListener('blur', () => {
      setTimeout(() => {
        if (sel.date) document.getElementById('sel-bar').classList.remove('hidden');
      }, 200);
    });
  });
  document.querySelectorAll('.form-input').forEach(el => {
    el.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { el.blur(); }
    });
  });
}

// ===== Expose functions to global scope for HTML onclick handlers =====
window.changeMonth = changeMonth;
window.goToTab = goToTab;
window.goTo = goTo;
window.goToConfirm = goToConfirm;
window.submitForm = submitForm;
window.selectCell = selectCell;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', tftInit);
} else {
  tftInit();
}
